import { render, staticRenderFns } from "./BackSnaploreButton.vue?vue&type=template&id=3121701a&"
import script from "./BackSnaploreButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BackSnaploreButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BackSnaploreButton.vue?vue&type=style&index=0&id=3121701a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports